import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Tabs,
  Tab,
  Divider,
  Button,
} from "@mui/material";

// Create-only templates (los creamos abajo)
import CreateFollowUpExam2Note from "../Templates/CreateFollowUpExam2Note";
import CreateHospitalDischargeFollowUpNote from "../Templates/CreateHospitalDischargeFollowUpNote";
import CreateAnnualWellnessNote from "../Templates/CreateAnnualWellnessNote";
import CreateTelehealthNote from "../Templates/CreateTelehealthNote";

function TabPanel({ value, index, children }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 2 }}>{children}</Box>;
}

export default function CreateClinicalNotePage() {
  const nav = useNavigate();
  const { state } = useLocation();

  const patientId = state?.patientId || "";
  const patient = state?.patient || null;

  const [tab, setTab] = React.useState(0);

  const onCancel = () => nav(-1);
  const onSaved = () => nav(-1); // o nav("/clinical-notes") si tienes listado

  if (!patientId) {
    return (
      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" fontWeight={800}>
            Missing patientId
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            This page must be opened from a patient context (Add Clinical Note).
          </Typography>
          <Button sx={{ mt: 2 }} variant="contained" onClick={() => nav(-1)}>
            Go Back
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, maxWidth: 1200, mx: "auto" }}>
      {/* Patient Header */}
      <Paper sx={{ p: 2 }}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center">
          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" fontWeight={900}>
              Create Clinical Note
            </Typography>
            <Typography color="text.secondary">
              Patient ID (AdvancedMD): <b>{patientId}</b>
            </Typography>

            {patient && (
              <Typography color="text.secondary" sx={{ mt: 0.5 }}>
                Patient: <b>{patient.fullName || patient.name || patient.patientName || "—"}</b>
                {" • "}
                DOB: <b>{patient.dob || patient.dateOfBirth || "—"}</b>
                {" • "}
                Gender: <b>{patient.gender || "—"}</b>
              </Typography>
            )}
          </Box>

          <Stack direction="row" spacing={1}>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
          </Stack>
        </Stack>

        <Divider sx={{ my: 2 }} />

        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Follow Up Exam 2.0" />
          <Tab label="Hospital Discharge FU" />
          <Tab label="Annual Wellness 2.0" />
          <Tab label="Telehealth 2.0" />
        </Tabs>
      </Paper>

      {/* Content */}
      <TabPanel value={tab} index={0}>
        <CreateFollowUpExam2Note patientId={patientId} patient={patient} onCancel={onCancel} onSaved={onSaved} />
      </TabPanel>

      <TabPanel value={tab} index={1}>
        <CreateHospitalDischargeFollowUpNote patientId={patientId} patient={patient} onCancel={onCancel} onSaved={onSaved} />
      </TabPanel>

      <TabPanel value={tab} index={2}>
        <CreateAnnualWellnessNote patientId={patientId} patient={patient} onCancel={onCancel} onSaved={onSaved} />
      </TabPanel>

      <TabPanel value={tab} index={3}>
        <CreateTelehealthNote patientId={patientId} patient={patient} onCancel={onCancel} onSaved={onSaved} />
      </TabPanel>
    </Box>
  );
}
